import React from 'react'
import { useState,useEffect } from 'react';
import ProductGrid4 from '../../components/public/pages/home/productGrid4';
import ApiUrl from '../../configTools/apiUrl';

const LikedList = () => {
  const User = JSON.parse(localStorage.getItem("user-info"));
    const [products,setProducts] = useState([]);

  useEffect(() => {
    fetch(ApiUrl.API_URL_Liked+"/"+User.username)
    .then(res=>res.json())
    .then(data =>{
        if(data.success)
        setProducts(data.responce);
    });
  },[User])
  return (
    <>
      <div className='listing_container'>
        <ProductGrid4 Products={products} Columns={5}/>
      </div>
    </>
  )
}

export default LikedList
